import { makeStyles } from 'tss-react/mui';

export default makeStyles({ name: 'MultiselectCheckbox' })(theme => ({
  option: {
    fontSize: 'var(--ebl-p2)',
    height: 'var(--ebl-dropdown-li-height)',

    border: '2px solid transparent',
    '&.Mui-focused': {
      '&[aria-selected="false"]': {
        backgroundColor: `${theme.palette.ebl.white} !important`,
        borderColor: theme.palette.ebl.focusColor,
      },
      '&[aria-selected="true"]': {
        backgroundColor: `${theme.palette.ebl.dropdownLiSelectedColor} !important`,
        borderColor: theme.palette.ebl.focusColor,
      },
    },
    '&:hover': {
      '&[aria-selected="false"]': {
        backgroundColor: `${theme.palette.ebl.dropdownLiHoverColor} !important`,
        borderColor: 'transparent',
      },
    },
  },
  noPadding: {
    padding: 0,
  },
  root: {
    border: `1px solid ${theme.palette.ebl.formelementBorderColor}`,
    boxShadow:
      '0px 3px 14px 2px rgba(0, 0, 0, 0.12), 0px 8px 10px 1px rgba(0, 0, 0, 0.14), 0px 5px 5px -3px rgba(0, 0, 0, 0.20)',
  },
  divider: {
    background: `${theme.palette.ebl.cardBorderColor}`,
  },
  selectAllOption: {
    fontFamily: 'Gilroy',
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: '700',
    letterSpacing: '0.5px',
    lineHeight: '24px',
  },
  disabledStyling: {
    '&.Mui-disabled': {
      opacity: '1',
      color: theme.palette.ebl.textBlack,
    },
  },
}));
